import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/creative-commons-pd': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111.1 248 248 0 137-111 248-248 248s-248-111-248-248c0-136.9 111-248 248-248zM248 457.5c76.1 0 142.4-42.4 176.7-104.8-1.4-0.3 12.5 5.8-217.9-96.8 0.2 32 16.1 71.9 53.9 71.9 18.7 0 30.8-10.4 36.3-16.7l36.1 43.9c-25.9 22.8-56.5 29.5-79.4 29.5-46.5 0-120.4-27.9-120.4-126.9 0-11.4 1.2-22.4 3.3-32.9l-78.8-35.1c-45.6 129.9 51 267.9 190.2 267.9zM442.2 307.5c0.2 0.2 0.3 0.3 0.6 0.4 4.4-16.6 6.8-34 6.8-52 0-111.1-90.4-201.5-201.5-201.5-70.4 0-132.4 36.3-168.5 91.2l74.9 33.4c19.8-31.1 53.3-51.6 100.7-51.6 20.1 0 51 4.2 78.1 27.5l-40.4 41.6c-19.8-19.7-55.9-23-74.7 11z'
      }
    ]
  }
})
